import {useEffect, useState} from "react";
import {useApp} from "../Contex";
import {fetchOrderReciept, getOrderItems, getOrders, refundOrder} from "../api/api";
import BottomSheet from "../components/BottomSheet";
import paymap from "../json/paymap.json"

function formatDateToYYYYMMDD(dateStr) {
    return dateStr.replace(/-/g, "");
}

function getToday() {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`; // format for <input type="date">
}

export default function Orders(){
    const [orders,setOrders] = useState([]);
    const [query, setQuery] = useState("")
    const [data, setData] = useState({});
    const [openOrder, setOpenOrder] = useState(null)
    const [orderToReturn, setOrderToReturn] = useState(null)
    const [refundMsg, setRefundMsg] = useState(null)
    const [fDate, setDate] = useState(getToday())
    const [showNonPaid, setShowNonPaid] = useState(false);
    const [loading, setLoading] = useState(false);
    const {refresh, permissions} = useApp()





    useEffect(() => {
            let isMounted = true;
            const fetchInitialOrders = async () => {
                setLoading(true);
                const res = await getOrders(formatDateToYYYYMMDD(fDate), !showNonPaid, query);
                if (res.ok && isMounted) {
                    setOrders(res.orders);
                    setData(res.data ?? {count: 8, total: 186800} )
                }
                setLoading(false);
            };

            fetchInitialOrders();

            return () => {
                isMounted = false;
            };

    }, [refresh, fDate, showNonPaid]);

    useEffect(() => {
        // Only run if no order is currently open
        if (openOrder === null && orderToReturn === null) {
            const intervalId = setInterval(async () => {
                console.log("refresh")
                const res = await getOrders(formatDateToYYYYMMDD(fDate), !showNonPaid, query);
                if (res.ok) {
                    setOrders(res.orders);
                }
            }, 6000);

            return () => clearInterval(intervalId);
        }

        // If openOrder is not null, do nothing (but cleanup if interval existed)
        return undefined;
    }, [fDate, showNonPaid, openOrder, orderToReturn]);

    const handleSearch = async() => {
        const res = await getOrders(formatDateToYYYYMMDD(fDate), !showNonPaid, query);
        if (res.ok) {
            setOrders(res.orders);
            setData(res.data ?? {count: 8, total: 186800} )
        }
    }




    const Openorder = ({ item }) => {
        const [order, setOrder] = useState(null);

        useEffect(() => {
            getOrderItems(item.order00.orderid).then((res) => {
                if (res.ok) {
                    setOrder(res.order);
                }
            });
        }, [item]);

        const handleReciept = () => {
            fetchOrderReciept(item.order00.orderid).then((res) => {
                if(res.ok){
                    window.open(res.link)
                }
            })
        }

        const o = item.order00;
        const c = item.order01;

        const isPaid = o.paid === "1";
        const date = `${o.datum.slice(0,4)}-${o.datum.slice(4,6)}-${o.datum.slice(6)}` ;
        const time = `${o.slot?.slice(0, 2) || "--"}:${o.slot?.slice(2) || "--"}`

        return (
            <div>
                <div className="d-flex align-items-start gap-3 mb-0">
                    <div className="text-nowrap">
                        <h3 className="fw-bold mb-0">Order #{parseInt(o.orderid, 10)}</h3>
                        <div><strong>Bord:</strong> {o.bord}</div>
                        <div><strong>Datum:</strong> {date}</div>
                        <div><strong>Tid:</strong> {time}</div>
                    </div>
                </div>
                <div className="mb-3">
                    <div><strong>Betalstatus:</strong> {isPaid ? "✔️ Betald" : "❌ Ej betald"}</div>
                    <div><strong>Betalmetod:</strong> {paymap[o.betkod] || "—"}</div>
                    <div><strong>Notanummer:</strong> {o.notanr || "—"}</div>
                    <div><strong>Telefon:</strong> {c.tele || "—"}</div>
                    {item.order03?.msg && (
                        <div className="mt-2">
                            <strong>Meddelande:</strong><br/>
                            <span className="fst-italic text-muted">{item.order03.msg}</span>
                        </div>
                    )}
                </div>

                <h5 className="mb-2">Produkter</h5>
                {order?.cart?.rows?.map((row, index) => (
                    <OrderRow item={row} key={index}/>
                ))}

                {order?.cart?.rows?.length === 0 && (
                    <p className="text-muted fst-italic">Inga artiklar i beställningen.</p>
                )}
                <hr/>
                <div className="d-flex align-items-center justify-content-between gap-2 mt-2">
                    <button className="btn btn-secondary" onClick={handleReciept}>Visa kvitto <i
                        className="bi bi-receipt-cutoff"></i></button>
                    {o.status?.trim() === "R" ? (
                        <span className="badge text-bg-secondary fs-6">Returnerad</span>
                    ) : isPaid && o.betkod?.trim() === "swis" && permissions?.write ? (
                        <button className="btn btn-outline-danger" onClick={() => {
                            setOrderToReturn({order, details: item})
                            setOpenOrder(null)
                        }}>Återbetala <i className="bi bi-cash-coin"></i>
                        </button>
                    ) : isPaid && permissions?.write ? (
                        <button className="btn btn-outline-secondary" disabled
                                title="Endast Swish-betalningar kan returneras i denna version">
                            Återbetala <i className="bi bi-cash-coin"></i>
                        </button>
                    ) : null}
                </div>
            </div>
        );
    };

    // Hel retur av en Swish-betald order. Delretur stöds inte av SRS ännu.
    const ReturnOrder = () => {
        const [confirm, setConfirm] = useState(false)
        const [busy, setBusy] = useState(false)
        const [error, setError] = useState(null)

        const {details} = orderToReturn ?? {};
        const o = details?.order00 ?? {};
        const orderNo = parseInt(o.orderid || "0", 10);
        const amount = (parseInt(o.belopp || "0", 10) / 100).toFixed(2);

        const close = () => {
            setOrderToReturn(null)
            if (details) setOpenOrder(details)
        }

        const doRefund = async () => {
            setBusy(true)
            setError(null)
            const res = await refundOrder(o.orderid)
            setBusy(false)
            if (res.ok) {
                const r = res.refund ?? {};
                const text = r.status === "PAID"
                    ? `Order #${orderNo} returnerad, ${amount} SEK via Swish${r.refundRef ? ` (ref ${r.refundRef})` : ""}.`
                    : `Order #${orderNo}: returen är skickad till Swish men ännu inte bekräftad (${r.status || "okänd status"}). Kontrollera i Swish Företag innan du försöker igen.`;
                setRefundMsg({type: r.status === "PAID" ? "success" : "warning", text})
                setOrderToReturn(null)
                handleSearch()
            } else {
                setError(`${res.error || "Returen kunde inte genomföras"}${res.code ? ` [${res.code}]` : ""}`)
            }
        }

        return (
            <BottomSheet
                show={orderToReturn}
                setShow={setOrderToReturn}
                onClose={() => {
                    if (details) setOpenOrder(details);
                }}
            >
                <h3 className="mb-3">Returnera order #{orderNo}</h3>
                <div className="mb-3">
                    <div><strong>Betalmetod:</strong> {paymap[o.betkod?.trim()] || o.betkod || "—"}</div>
                    <div><strong>Notanummer:</strong> {o.notanr || "—"}</div>
                    <div><strong>Belopp att returnera:</strong> {amount} SEK</div>
                </div>
                <p className="text-muted small">
                    Hela beloppet returneras till kundens Swish. Delretur stöds inte ännu. Åtgärden kan inte ångras.
                </p>
                {error && <div className="alert alert-danger py-2">{error}</div>}
                {!confirm ? (
                    <div className="d-flex justify-content-between">
                        <button className="btn btn-secondary" onClick={close} disabled={busy}>Avbryt</button>
                        <button className="btn btn-outline-danger" onClick={() => setConfirm(true)} disabled={busy}>
                            Returnera hela beloppet
                        </button>
                    </div>
                ) : (
                    <div className="d-flex justify-content-between align-items-center">
                        <button className="btn btn-secondary" onClick={() => setConfirm(false)} disabled={busy}>Tillbaka</button>
                        <button className="btn btn-danger" onClick={doRefund} disabled={busy}>
                            {busy
                                ? <><span className="spinner-border spinner-border-sm me-2" role="status"/>Skickar till Swish…</>
                                : `Bekräfta retur ${amount} SEK`}
                        </button>
                    </div>
                )}
            </BottomSheet>
        );
    };


    const OrderRow = ({ item}) => {
        const price = (parseInt(item.belopp, 10) / 100).toFixed(2);
        const quantity = parseInt(item.antal || "1", 10);
        const total = (price * quantity).toFixed(2);

        return (
            <div className="card mb-2 shadow-sm">
                <div className="card-body p-2">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <strong>{item.text}</strong>
                        <span className="fw-semibold">{total} kr</span>
                    </div>

                    <div className="d-flex justify-content-between">
                        <div className="text-muted small">
                            <span>PLU: {item.plu}</span>
                            {quantity > 1 && <span> &nbsp;|&nbsp; Antal: {quantity}</span>}
                            <span> &nbsp;|&nbsp; Pris/st: {price} kr</span>
                            {item.comment && <span> &nbsp;|&nbsp; Kommentar: “{item.comment}”</span>}
                        </div>
                    </div>
                </div>
            </div>
        );
    };


    const OrderItem = ({item}) => {
        const paid = item.order00.paid === "1";
        return <div className={`card mb-2 p-2 bg-light d-flex justify-content-between flex-row ${!paid && "bg-danger-subtle"}`} onClick={()=>{
            setOpenOrder(item)
        }}>
            <div>
                <p className="mb-0">Order {parseInt(item.order00.orderid)}</p>
                <p className="mb-0">{parseInt(item.order00.belopp) / 100} SEK</p>
            </div>
            <div>
                <p className="mb-0">Bord {item.order00.bord}</p>
                {paid && <p className="mb-0">{item.order00.notanr}</p>}
                {item.order00.status?.trim() === "R" && <span className="badge text-bg-secondary">Returnerad</span>}
            </div>
        </div>
    }
    return (
        <>
        <h1 className="mb-4">Beställningar</h1>

            <div className="d-flex align-items-center gap-3 flex-wrap mb-4">
                <div>
                    <label className="form-label mb-1" htmlFor="order-date">Datum</label>
                    <div className="d-flex gap-1">
                        <button
                            className="btn btn-outline-success"
                            onClick={() => {
                                setDate((prev) => {
                                    const date = new Date(prev);
                                    date.setDate(date.getDate() - 1);
                                    return date.toISOString().split("T")[0]; // format as YYYY-MM-DD
                                });
                            }}
                        >
                            {"<"}
                        </button>

                        <input
                            id="order-date"
                            className="form-control"
                            type="date"
                            value={fDate}
                            onChange={(e) => setDate(e.target.value)}
                        />

                        <button
                            className="btn btn-outline-success"
                            onClick={() => {
                                setDate((prev) => {
                                    const date = new Date(prev);
                                    date.setDate(date.getDate() + 1);
                                    return date.toISOString().split("T")[0]; // format as YYYY-MM-DD
                                });
                            }}
                        >
                            {">"}
                        </button>
                    </div>

                </div>

                <div className="form-check mt-4">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="show-non-paid"
                        checked={showNonPaid}
                        onChange={(e) => setShowNonPaid(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="show-non-paid">
                        Visa obetalda
                    </label>
                </div>
            </div>
            <div className="d-flex align-items-center gap-3 flex-wrap mb-4">
                <div className="d-flex gap-1">
                <input className="form-control" placeholder="Sök notanr, bordsnr, etc..." value={query} onKeyDown={(e)=>{
                    if(e.key === "Enter") {
                        handleSearch()
                    }
                }} onChange={(e)=>{
                    setQuery(e.target.value)
                }}/>
                    <button className="btn btn-outline-secondary mr-2" onClick={handleSearch}>
                        <span>sök</span>
                    </button>
                </div>
            </div>

            {loading ?
                <div className="d-flex justify-content-center my-4">
                    <div className="spinner-border text-warning" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>

                : <>
                    <div
                        className="d-flex gap-4 align-items-center mb-3 p-2 bg-light border rounded shadow-sm">
                        <span><strong>Antal:</strong> {data.count}</span>
                        <span><strong>Belopp:</strong> {(data.total / 100).toFixed(2)} SEK</span>
                    </div>


                    {refundMsg && (
                        <div className={`alert alert-${refundMsg.type} d-flex justify-content-between align-items-center`} role="alert">
                            <span>{refundMsg.text}</span>
                            <button type="button" className="btn-close" aria-label="Stäng" onClick={() => setRefundMsg(null)}/>
                        </div>
                    )}
                    {orders.map((item, index) => <OrderItem item={item} key={index}/>)}
                    {orders.length === 0 && <span className="fs-3 fw-semibold">Inga beställningar</span>}

                </>}
            <BottomSheet show={openOrder} setShow={setOpenOrder} children={<Openorder item={openOrder}/>}/>
            <ReturnOrder/>
        </>

    )
}
